import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sondermind/http';
import { IAPIFetchResponse, IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';
import {
  IClientReferralApiResponse,
  ClientReferral,
  InternalReferralDetailsResponse,
  InternalReferralDetails,
} from '@sondermind/utilities/models-clinical';
import { ClientReferralLite, IClientReferralLiteApiResponse } from '@sondermind/data-access/client-referral';
import { ConfigurationService } from '@sondermind/configuration';

export interface IProviderInvitedReferralRequestBody {
  first_name: string;
  last_name: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClientReferralHttpService {
  private readonly baseUrl: string = `${this.configurationService.env.svcBase}/referrals/client_referrals`;

  constructor(
    private http: HttpService,
    private configurationService: ConfigurationService
  ) {}

  getInternalReferralDetails$(clientReferralId: number): Observable<IAPIFetchResponse<InternalReferralDetails>> {
    return this.http.get<IAPIFetchResponse<InternalReferralDetailsResponse>>(
      `${this.baseUrl}/${clientReferralId}/internal_referral_detail`
    )
      .pipe(
        map((resp) => ({
          ...resp,
          data: new InternalReferralDetails(resp.data)
        }))
      );
  }

  getClientReferral$(
    clientReferralId: number,
    opts: Partial<IAPIListRequestOptions> = {}
  ): Observable<IAPIFetchResponse<ClientReferral>> {
    const params = this.http.generateListParams(opts);

    return this.http.get<IAPIFetchResponse<IClientReferralApiResponse>>(`${this.baseUrl}/${clientReferralId}`, params)
      .pipe(
        map((resp) => ({
          ...resp,
          data: new ClientReferral(resp.data)
        }))
      );
  }

  getReferrals$(opts: Partial<IAPIListRequestOptions> = {}): Observable<IAPIListResponse<ClientReferral>> {
    const params = this.http.generateListParams(opts);

    return this.http.get<IAPIListResponse<IClientReferralApiResponse>>(this.baseUrl, params)
      .pipe(
        map((resp) => ({
          ...resp,
          data: resp.data.map((referral) => new ClientReferral(referral))
        }))
      );
  }

  createProviderInvitedReferral$(data: IProviderInvitedReferralRequestBody): Observable<IAPIFetchResponse<ClientReferralLite>> {
    const url = `${this.configurationService.env.svcBase}/referrals/api/v1/provider_invited`;
    return this.http.post<IAPIFetchResponse<IClientReferralLiteApiResponse>>(url, data)
      .pipe(
        map((resp) => ({
          ...resp,
          data: new ClientReferralLite(resp.data)
        })),
        this.http.handleHttpErrorStrict()
      );
  }
}
